import { gql } from '@apollo/client';
import { apolloClient } from '../../../utils/apollo';

const CREATE_USER_BORROWER_AND_LOAN = gql`
  mutation CreateUserBorrowerAndLoan($input: OnboardBorrowerInput!) {
    createUserBorrowerAndLoan(onboardBorrowerInput: $input) {
      token
      loanId
    }
  }
`;

const CREATE_LOAN_WITH_OWNERSHIP = gql`
  mutation CreateLoanWithOwnership($input: CreateLoanWithOwnershipInput!) {
    createLoanWithOwnership(createLoanWithOwnershipInput: $input) {
      token
      loanId
    }
  }
`;

const GET_OWNERSHIPS_BY_CREATOR = gql`
  query GetOwnershipsByCreatorOnboarding($ownerId: String!) {
    GetOwnershipsByCreator(ownerId: $ownerId) {
      _id
      name
      lastname
      phone
      email
      state
      loans {
        _id
        loanData
      }
    }
  }
`;

export interface OnboardBorrowerInput {
  name?: string;
  phone?: string;
  email?: string;
  password?: string;
  loanData?: any;
  urlParams?: string;
}

export interface CreateLoanWithOwnershipInput {
  _id?: string;
  name?: string;
  phone?: string;
  email?: string;
  loanData?: any;
  urlParams?: string;
}

export interface OnboardingResponse {
  token: string;
  loanId: string;
}

export class OnboardingService {
  /**
   * Create a new user, borrower, and loan in a single mutation
   */
  async createUserBorrowerAndLoan(input: OnboardBorrowerInput): Promise<OnboardingResponse> {
    try {
      const { data } = await apolloClient.mutate({
        mutation: CREATE_USER_BORROWER_AND_LOAN,
        variables: { input },
        fetchPolicy: 'no-cache',
      });
      return data.createUserBorrowerAndLoan;
    } catch (error) {
      console.error('Error creating user borrower and loan:', error);
      throw error;
    }
  }

  /**
   * Create a loan with an existing ownership
   */
  async createLoanWithOwnership(input: CreateLoanWithOwnershipInput): Promise<OnboardingResponse> {
    try {
      const { data } = await apolloClient.mutate({
        mutation: CREATE_LOAN_WITH_OWNERSHIP,
        variables: { input },
        fetchPolicy: 'no-cache',
      });
      return data.createLoanWithOwnership;
    } catch (error) {
      console.error('Error creating loan with ownership:', error);
      throw error;
    }
  }

  /**
   * Get ownerships by creator ID
   */
  async getOwnershipsByCreator(ownerId: string) {
    try {
      const { data } = await apolloClient.query({
        query: GET_OWNERSHIPS_BY_CREATOR,
        variables: { ownerId },
        fetchPolicy: 'network-only',
      });
      return data.GetOwnershipsByCreator;
    } catch (error) {
      console.error('Error fetching ownerships:', error);
      throw error;
    }
  }
}

// Export singleton instance
export const onboardingService = new OnboardingService();
